const THOUSAND = 1000
const MILLION = 1e6
const BILLION = 1e9
const TRILLION = 1e12

export function readableNumber(number: number, precision = 2) {
  try {
    if (number >= TRILLION) return `${(number / TRILLION).toFixed(precision)}T`
    if (number >= BILLION) return `${(number / BILLION).toFixed(precision)}G`
    if (number >= MILLION) return `${(number / MILLION).toFixed(precision)}M`
    if (number >= THOUSAND) return `${(number / THOUSAND).toFixed(precision)}K`
    return `${(number).toFixed(precision)}`
  }

  catch (excepcion) {

    return `${(number)}`
  }

}
